import { proxyBE } from './common';

export const lessonTrainingService = {   

    MyScheduleTraining(courseId, rCode, trainingType = "") {
        let url = `/lesson/training/my-schedule-training/${courseId}/${rCode}/${trainingType}`;
        return proxyBE.get(url);
    },

    myTraining(id, registrationCode) {
        return proxyBE.get('/lesson/training/my-training/' + registrationCode + '/' + id);
    },

    generateAttendance(payload) {
        return proxyBE.post('/lesson/training/create-attendance/', { payload });
    },

    myAnalyticResume(rCode) {
        return proxyBE.post('/lesson/training/my-analytics-resume/' + rCode);
    },

    donwloadAttendance(id) {
        return proxyBE.get('/lesson/training/download-attendance/' + id);
    },

    loadFile(fileId) {
        return proxyBE.get('/lessontrainingschedule-file-slide/get/' + fileId);
    },    
}